import React from "react";

const CompanyAddress = ({
  align = "end",
  company = "New-Way Trucking Ltd",
  street = "7725 48 St. SE, Calgary",
  region = "Alberta, Canada T2C 2V3",
}) => {
  return (
    <div className={`col-3 text-${align}`}>
      <strong>{company}</strong>
      <br />
      {street}
      <br />
      {region}
    </div>
  );
};

export default CompanyAddress;
